import React, { useEffect, useState } from "react";
import { motion } from "motion/react";

import FlightTakeoffRoundedIcon from "@mui/icons-material/FlightTakeoffRounded";
import ScheduleSendRoundedIcon from "@mui/icons-material/ScheduleSendRounded";
import GavelRoundedIcon from "@mui/icons-material/GavelRounded";
import AcUnitRoundedIcon from "@mui/icons-material/AcUnitRounded";
import WarehouseRoundedIcon from "@mui/icons-material/WarehouseRounded";
import CommuteRoundedIcon from "@mui/icons-material/CommuteRounded";
import DirectionsBoatRoundedIcon from "@mui/icons-material/DirectionsBoatRounded";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import Inquire from "./Inquire";
import useIntersect from "./util/useIntersect";
import Modal from "./Modal";
import { KeyboardArrowUp } from "@mui/icons-material";
import img from "../images/113094-OOR2CK-829-ai.png";

const responsive = {
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 4,
    slidesToSlide: 1, // optional, default to 1.
  },
  tablet: {
    breakpoint: { max: 1024, min: 680 },
    items: 2,
    slidesToSlide: 1, // optional, default to 1.
  },
  mobile: {
    breakpoint: { max: 680, min: 0 },
    items: 1,
    slidesToSlide: 1, // optional, default to 1.
  },
};
const Services = () => {
  const [ref, entry] = useIntersect({
    threshold: 0,
    rootMargin: "-50% 0% -50% 0%",
  });
  useEffect(() => {
    if (entry.isIntersecting) {
      if (entry.isIntersecting) {
        document.querySelectorAll(".nav-link").forEach((i) => {
          i.classList.remove("active");
        });
        document.getElementById("nav-services").classList.add("active");
        // setPosition1("services");
        // document.getElementById("service-title").classList.add("show-line");
      }
    }
    // eslint-disable-next-line
  }, [entry.isIntersecting]);
  const [open, setOpen] = useState(false);
  const [modal, setModal] = useState({ state: false, value: null });
  const [type, setType] = useState(null);
  const [service, setService] = useState(null);
  const [shipment, setShipment] = useState(null);

  return (
    <div
      className="services w-full lg:p-[4rem] p-[2rem] lg:pt-[2rem] pt-[2rem]"
      id="services"
      ref={ref}
    >
      <h2 className="section-title">Seamless Air & Sea Solutions</h2>
      <p className="services-paragraph">
        Explore our comprehensive services tailored to streamline your logistics with end to end solutions:
      </p>
      <br />
      <br />
      <div className="grid grid-cols-1 gap-3 w-full">
        <div className="services-container-2 gap-7 lg:translate-y-0 translate-y-[-2rem] w-full">
          <div className="service w-full">
            <div className="service-title">
              <FlightTakeoffRoundedIcon
                fontSize="2.3rem"
                className="service-icon"
              />
              <h4 className="service-title-text">Air Freight Solutions</h4>
            </div>
            <div className="service-bold">
              Swift, Secure, Specialized: Your Air Cargo Solution
            </div>
            <p className="service-desc">
              Saharawinds Ltd offers reliable and efficient air cargo solutions
              tailored to your needs, with guaranteed capacity through block
              space agreements and a global network ensuring seamless deliveries
              to key destinations. Specializing in time-sensitive shipments,
              door-to-door logistics, and expert customs clearance, Saharawinds
              navigates the complexities of international trade with precision,
              ensuring compliance and minimizing supply chain risks. With
              advanced tracking for real-time shipment visibility and
              competitive pricing, Saharawinds is your trusted partner for
              cost-effective, hassle-free air freight logistics.
            </p>{" "}
            <div>
              <button
                className="service-rm"
                onClick={() =>
                  setModal({ state: true, value: "Air Freight Solutions" })
                }
              >
                Read More
              </button>
              <button
                className="service-cta"
                onClick={() => {
                  setType("inquiry");
                  setService("Air Freight Solutions");
                  setOpen(true);
                }}
              >
                Inquire Now
              </button>
            </div>
          </div>
          <div className="service w-full even">
            <div className="service-title">
              <DirectionsBoatRoundedIcon
                fontSize="2.3rem"
                className="service-icon"
              />
              <h4 className="service-title-text">Sea Freight Solutions</h4>
            </div>
            <div className="service-bold">
              Seamless Global Shipping, Cost-Effective Solutions
            </div>
            <p className="service-desc">
              Saharawinds Ltd provides reliable and cost-effective sea freight
              solutions through partnerships with leading shipping lines,
              offering Full Container Load (FCL), Less Than Container Load
              (LCL), break bulk, and project cargo services tailored to diverse
              shipping needs. With a global network, seamless door-to-door
              logistics, expert customs clearance, and proactive risk
              management, Saharawinds ensures efficient transportation from
              origin to destination. By optimizing shipping routes and offering
              competitive rates, Saharawinds is your trusted partner for
              dependable and hassle-free sea freight logistics.
            </p>{" "}
            <div>
              <button
                className="service-rm"
                onClick={() =>
                  setModal({ state: true, value: "Sea Freight Solutions" })
                }
              >
                Read More
              </button>
              <button
                className="service-cta"
                onClick={() => {
                  setType("inquiry");
                  setService("Sea Freight Solutions");
                  setOpen(true);
                }}
              >
                Inquire Now
              </button>
            </div>
          </div>
        </div>
        <div className="services-container gap-7">
          <div className="service w-full">
            <div className="service-title">
              <ScheduleSendRoundedIcon
                fontSize="2.3rem"
                className="service-icon"
              />
              <h4 className="service-title-text">
                Charter Air Freight Services
              </h4>
            </div>
            <div className="service-bold">
              Urgent Deliveries, Swift Solutions
            </div>
            <p className="service-desc">
              Saharawinds Ltd offers dedicated air charter solutions for
              time-critical shipments, ensuring urgent deliveries are completed
              on schedule. With exclusive aircraft use, optimized direct routes,
              flexible scheduling, and priority handling from customs clearance
              to delivery, Saharawinds provides seamless end-to-end support.
              Backed by an experienced team, they tailor services to meet
              specific deadlines and logistical needs, minimizing delays and
              ensuring a smooth, efficient process. Trust Saharawinds for
              reliable and timely charter solutions to keep your business
              moving.
            </p>{" "}
            <div>
              <button
                className="service-rm"
                onClick={() =>
                  setModal({
                    state: true,
                    value: "Charter Air Freight Services",
                  })
                }
              >
                Read More
              </button>
              <button
                className="service-cta"
                onClick={() => {
                  setType("inquiry");
                  setService("Charter Air Freight Services");
                  setOpen(true);
                }}
              >
                Inquire Now
              </button>
            </div>
          </div>

          <div className="service even w-full">
            <div className="service-title">
              <WarehouseRoundedIcon
                fontSize="2.3rem"
                className="service-icon"
              />
              <h4 className="service-title-text">
                Warehousing and Cargo Consolidation
              </h4>
            </div>
            <div className="service-bold">
              Efficient Storage and Cost Savings
            </div>
            <p className="service-desc">
              Saharawinds Ltd offers comprehensive warehousing solutions
              designed to ensure the safety, integrity, and efficiency of your
              supply chain. Our secure warehousing and state of the art cold
              storage facilities maintain optimal conditions for a wide range of
              goods, including temperature-sensitive items. We also provide
              custom packaging services tailored to protect your products during
              transit. Additionally, our expertise in cargo consolidation for
              export and deconsolidation for imports helps optimize space
              utilization, reduce costs, and streamline the logistics process,
              ensuring timely and cost-effective delivery. At Saharawinds, we
              are committed to enhancing logistics efficiency while meeting your
              unique requirements.
            </p>{" "}
            <div>
              <button className="service-rm" disabled style={{ opacity: 0 }}>
                Read More
              </button>
              <button
                className="service-cta"
                onClick={() => {
                  setType("inquiry");
                  setService("Warehousing");
                  setOpen(true);
                }}
              >
                Inquire Now
              </button>
            </div>
          </div>

          <div className="service w-full">
            <div className="service-title">
              <CommuteRoundedIcon fontSize="2.3rem" className="service-icon" />
              <h4 className="service-title-text">Road and Railway Transport</h4>
            </div>
            <div className="service-bold">
              Reliable Inland Transport Across Kenya and Beyond
            </div>
            <p className="service-desc">
              Saharawinds Ltd offers comprehensive road and railway transport
              services, ensuring that goods are delivered efficiently and
              reliably across Kenya and the wider East Africa region. We
              prioritize timely delivery and secure handling for every shipment,
              maintaining the highest standards of care and professionalism. Our
              logistics solutions are tailored to meet diverse transportation
              needs, from bulk cargo to time-sensitive deliveries, leveraging
              our extensive network and expertise to guarantee seamless and
              cost-effective operations. With Saharawinds, shippers can trust
              that their goods will reach their destinations safely and on
              schedule, contributing to smooth and efficient supply chain
              management across the region.
            </p>
            <div>
              <button
                className="service-rm"
                onClick={() =>
                  setModal({ state: true, value: "Road and Railway Transport" })
                }
              >
                Read More
              </button>
              <button
                className="service-cta"
                onClick={() => {
                  setType("inquiry");
                  setService("Road and Railway Transport");
                  setOpen(true);
                }}
              >
                Inquire Now
              </button>
            </div>
          </div>
        </div>
        <div className="services-container-2 gap-7">
          <div className="service even w-full">
            <div className="service-title">
              <GavelRoundedIcon fontSize="2.3rem" className="service-icon" />
              <h4 className="service-title-text">
                Customs Clearance for Imports and Exports
              </h4>
            </div>
            <div className="service-bold">
              Navigating the Complexities of Cross Border Trade
            </div>
            <p className="service-desc">
              Saharawinds Ltd simplifies cross-border trade with expert customs
              clearance services, leveraging deep knowledge of import/export
              regulations and trade agreements to ensure smooth, compliant, and
              cost-effective logistics. Offering comprehensive support from
              documentation to post-clearance formalities, Saharawinds handles
              import and export procedures, regulatory compliance, preferential
              trade agreements, and complex requirements like tariff
              classification, sanitary protocols, and intellectual property
              rights. With an experienced team, a global network, proactive risk
              management, and personalized support, Saharawinds ensures seamless
              customs processes and optimized supply chain costs. Trust
              Saharawinds for efficient and reliable cross-border trade
              solutions.
            </p>{" "}
            <div>
              <button
                className="service-rm"
                onClick={() =>
                  setModal({ state: true, value: "Customs Clearance" })
                }
              >
                Read More
              </button>
              <button
                className="service-cta"
                onClick={() => {
                  setType("inquiry");
                  setService("Customs Clearance");
                  setOpen(true);
                }}
              >
                Inquire Now
              </button>
            </div>
          </div>

          <div className="service w-full">
            <div className="service-title">
              <AcUnitRoundedIcon fontSize="2.3rem" className="service-icon" />
              <h4 className="service-title-text">
                Cold Chain Logistics for Perishables
              </h4>
            </div>
            <div className="service-bold">
              Preserving Quality for Temperature-Sensitive Cargo
            </div>
            <p className="service-desc">
              Saharawinds Ltd specializes in door-to-door cool chain logistics,
              ensuring the quality and freshness of perishable shipments like
              cut flowers, fresh produce, chilled and frozen meat, and seafood
              from source to destination. With temperature-controlled
              warehousing, refrigerated transportation, real-time monitoring,
              and customized cold chain solutions, Saharawinds maintains optimal
              conditions throughout the supply chain. Their experienced team
              provides additional services such as product inspection,
              packaging, labelling, and customs clearance to streamline
              logistics. Leveraging advanced technology, a global network, and a
              customer-centric approach, Saharawinds delivers cost-effective,
              reliable, and tailored solutions for seamless cool chain
              operations.
            </p>{" "}
            <div>
              <button
                className="service-rm"
                onClick={() =>
                  setModal({ state: true, value: "Cold Chain Management" })
                }
              >
                Read More
              </button>
              <button
                className="service-cta"
                onClick={() => {
                  setType("inquiry");
                  setService("Cold Chain Management");
                  setOpen(true);
                }}
              >
                Inquire Now
              </button>
            </div>
          </div>
        </div>
      </div>
      <br />
      <br />
      <h2 className="section-title-2">
        Leading Experts in Shipping Perishable Cargo Shipments
      </h2>

      <Carousel
        swipeable={false}
        draggable={false}
        showDots={false}
        responsive={responsive}
        ssr={true} // means to render carousel on server-side.
        infinite={true}
        // autoPlay={this.props.deviceType !== "mobile" ? true : false}
        // autoPlaySpeed={1000}
        centerMode={true}
        keyBoardControl={true}
        customTransition="transform 0.5s ease-in-out"
        containerClass="carousel-container"
        // removeArrowOnDeviceType={["tablet", "mobile"]}
        // deviceType={this.props.deviceType}
        // dotListClass="custom-dot-list-style"
        itemClass="carousel-item-padding-40-px"
        className="carousel rounded-lg mt-20 w-full mx-[1rem] translate-x-[-1rem] h-fit"
      >
        <div
          className="item mango"
          onClick={() =>
            setModal({ state: true, value: "Fruits & Vegatables" })
          }
        >
          <div className="cargo-title w-full">
            <b>Kenyan Mango</b>
          </div>
          <button
            className="cta-item"
            onClick={(e) => {
              e.stopPropagation();
              setType("shipment");
              setShipment("Mango");
              setOpen(true);
            }}
          >
            Book Shipment
          </button>
        </div>
        <div
          className="item avocado"
          onClick={() => setModal({ state: true, value: "Kenyan Avocado" })}
        >
          <div className="cargo-title w-full">
            <b>Kenyan Avocado</b>
          </div>
          <button
            className="cta-item"
            onClick={(e) => {
              e.stopPropagation();
              setType("shipment");
              setShipment("Avocado");
              setOpen(true);
            }}
          >
            Book Shipment
          </button>
        </div>
        <div
          className="item pineapple"
          onClick={() =>
            setModal({ state: true, value: "Fruits & Vegatables" })
          }
        >
          <div className="cargo-title w-full">
            <b>Kenyan Pineapple</b>
          </div>
          <button
            className="cta-item"
            onClick={(e) => {
              e.stopPropagation();
              setType("shipment");
              setShipment("Pineapple");
              setOpen(true);
            }}
          >
            Book Shipment
          </button>
        </div>
        <div
          className="item veg"
          onClick={() =>
            setModal({ state: true, value: "Fruits & Vegatables" })
          }
        >
          <div className="cargo-title w-full">
            <b>Kenyan Vegetables</b>
          </div>
          <button
            className="cta-item"
            onClick={(e) => {
              e.stopPropagation();
              setType("shipment");
              setShipment("Vegetables");
              setOpen(true);
            }}
          >
            Book Shipment
          </button>
        </div>
        <div
          className="item flowers"
          onClick={() => setModal({ state: true, value: "Kenyan Flowers" })}
        >
          <div className="cargo-title w-full">
            <b>Kenyan Flowers</b>
          </div>
          <button
            className="cta-item"
            onClick={(e) => {
              e.stopPropagation();
              setType("shipment");
              setShipment("Flowers");
              setOpen(true);
            }}
          >
            Book Shipment
          </button>
        </div>
        <div
          className="item meat larger"
          onClick={() => setModal({ state: true, value: "Goat & Lamp Meat" })}
        >
          <div className="cargo-title w-full">
            <b>Goat & Lamp Meat</b>
          </div>
          <button
            className="cta-item"
            onClick={(e) => {
              e.stopPropagation();
              setType("shipment");
              setShipment("Meat");
              setOpen(true);
            }}
          >
            Book Shipment
          </button>
        </div>
      </Carousel>
      <h2 className="section-title-2">
        Trusted Leaders in Shipping General Cargo Shipments
      </h2>

      <Carousel
        swipeable={false}
        draggable={false}
        showDots={false}
        responsive={responsive}
        ssr={true} // means to render carousel on server-side.
        infinite={true}
        // autoPlay={this.props.deviceType !== "mobile" ? true : false}

        // autoPlaySpeed={1000}
        centerMode={true}
        keyBoardControl={true}
        customTransition="transform 0.5s ease-in-out"
        containerClass="carousel-container"
        // removeArrowOnDeviceType={["tablet", "mobile"]}
        // deviceType={this.props.deviceType}
        // dotListClass="custom-dot-list-style"
        itemClass="carousel-item-padding-40-px"
        className="carousel rounded-lg mt-20 mx-[1rem] w-full translate-x-[-1rem] h-fit"
      >
        <div
          className="item dgr"
          onClick={() =>
            setModal({ state: true, value: "Dangerous Goods (DGR Cargo)" })
          }
        >
          <div className="cargo-title w-full">
            <b>Dangerous Goods</b>
          </div>
          <button
            className="cta-item"
            onClick={(e) => {
              e.stopPropagation();
              setType("shipment");
              setShipment("Dangerous Goods (DGR Cargo)");
              setOpen(true);
            }}
          >
            Book Shipment
          </button>
        </div>
        <div
          className="item pharma"
          onClick={() =>
            open
              ? setModal({ state: false, value: null })
              : setModal({ state: true, value: "Pharma & Healthcare" })
          }
        >
          <div className="cargo-title w-full">
            <b>Pharma & Healthcare</b>
          </div>
          <button
            className="cta-item"
            onClick={(e) => {
              e.stopPropagation();
              setType("shipment");
              setShipment("Pharma & Healthcare");
              setOpen(true);
              setModal({ state: false, value: null });
            }}
          >
            Book Shipment
          </button>
        </div>
        <div
          className="item hs"
          onClick={() =>
            setModal({ state: true, value: "Humanitarian Support Logistics" })
          }
        >
          <div className="cargo-title w-full">
            <b>Humanitarian Support</b>
          </div>
          <button
            className="cta-item"
            onClick={(e) => {
              e.stopPropagation();
              setType("shipment");
              setShipment("Humanitarian Support Logistics");
              setOpen(true);
            }}
          >
            Book Shipment
          </button>
        </div>
        <div
          className="item me"
          onClick={() =>
            setModal({ state: true, value: "Machinery & Equipment" })
          }
        >
          <div className="cargo-title w-full">
            <b>Machinery & Equipment</b>
          </div>
          <button
            className="cta-item"
            onClick={(e) => {
              e.stopPropagation();
              setType("shipment");
              setShipment("Machinery & Equipment");
              setOpen(true);
            }}
          >
            Book Shipment
          </button>
        </div>
        <div
          className="item cts"
          onClick={() =>
            setModal({ state: true, value: "Time-critical Logistics" })
          }
        >
          <div className="cargo-title w-full">
            <b>Time-critical Logistics</b>
          </div>
          <button
            className="cta-item"
            onClick={(e) => {
              e.stopPropagation();
              setType("shipment");
              setShipment("Time-critical Logistics");
              setOpen(true);
            }}
          >
            Book Shipment
          </button>
        </div>
        <div
          className="item fashion"
          onClick={() =>
            setModal({
              state: true,
              value: "Saharawinds - Fashion & Textile Shipments",
            })
          }
        >
          <div className="cargo-title w-full">
            <b>Fashion & Textile</b>
          </div>
          <button
            className="cta-item"
            onClick={(e) => {
              e.stopPropagation();
              setType("shipment");
              setShipment("Fashion & Textile Shipments");
              setOpen(true);
            }}
          >
            Book Shipment
          </button>
        </div>
        <div
          className="item animal"
          onClick={() =>
            setModal({
              state: true,
              value: "Saharawinds - Live Animals & Live Seafood",
            })
          }
        >
          <div className="cargo-title w-full">
            <b>Live Animals</b>
          </div>
          <button
            className="cta-item"
            onClick={(e) => {
              e.stopPropagation();
              setType("shipment");
              setShipment("Live Animals & Live Seafood");
              setOpen(true);
            }}
          >
            Book Shipment
          </button>
        </div>
      </Carousel>
      <br />
      <br />
      <br />
      <div className="cta-div m-0 w-full relative rounded-3xl">
        <h2 className="cta-text font-normal">
          <span className="font-black">
          Pathway to Global Reach
          </span>{" "}
          <p className="text-base mt-4 lg:pt-3 pt-0 pb-4">
            <span className=" font-bold">Saharawinds </span>
            <i className="text-sm mb-4"> - Logistics Excellence</i>
          </p>
        </h2>
        {/* <div className="absolute bottom-2"></div> */}
        <img src={img} alt="" className="cta-img" />
      </div>

      <Inquire
        setOpen={setOpen}
        open={open}
        type={type}
        service={service}
        shipment={shipment}
      />

      <Modal modal={modal} setModal={setModal} />
    </div>
  );
};

export default Services;
